import React, { useState, useEffect } from "react";
import "./BillwiseReport.css";

export default function PurchasePartywiseReport({fromDate,toDate}) {

  const [reportData, setReportData] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  const [totalKg, setTotalKg] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchReport();
    }
  }, [fromDate, toDate]);

  const fetchReport = async () => {

    const res = await fetch(
      `/api/purchase-report/partywise?from=${fromDate}&to=${toDate}`
    );

    const data = await res.json();

 const processed = data.map(row => ({
  partyName: row[0],
  totalQty: Number(row[1] || 0),
  totalKg: Number(row[2] || 0),
  unitType: row[3] || "",
  totalAmount: Number(row[4] || 0)
}));

    setReportData(processed);

    setTotalQty(
      processed.reduce((sum, row) => sum + row.totalQty, 0)
    );

    setTotalKg(
     processed.reduce((sum, row) => sum + row.totalQty, 0)
    );

    setTotalAmount(
      processed.reduce((sum, row) => sum + row.totalAmount, 0)
    );
  };

  const handlePrint = () => {

  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
    <html>
    <head>
      <title>Purchase Partywise Report</title>
      <style>
        body { font-family: Arial; padding: 20px; }

        .report-wrapper {
          border: 2px solid #000;
          padding: 10px;
        }

      .header-section {
  position: relative;
  margin: -10px -10px 15px -10px;   /* extend to wrapper border */
  border-bottom: 2px solid #000;
  padding: 10px 10px 10px 10px;
}
        .company-section { text-align: center; }

        .title { font-size: 20px; font-weight: bold; }
        .sub-title { font-size: 14px; }

        .date-section {
          position: absolute;
          right: 0;
          top: 0;
          text-align: right;
          font-weight: bold;
          font-size: 14px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        th, td {
          border: 1px solid #000;
          padding: 6px;
          text-align: center;
        }

        th { background: #eaeaea; }
        tfoot td { font-weight: bold; }

      </style>
    </head>

    <body>

      <div class="report-wrapper">

        <div class="header-section">

          <div class="company-section">
            <div class="title">ORANGE TRADINGS</div>
            <div class="sub-title">DHARAPURAM ROAD, TIRUPUR - 641 601</div>
          </div>

          <div class="date-section">
            <div>From Date : ${fromDate}</div>
            <div>To Date&nbsp;&nbsp;&nbsp;: ${toDate}</div>
          </div>

        </div>

        <table>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Total Qty</th>
              <th>U/A</th>
              <th>Total Amount</th>
            </tr>
          </thead>

          <tbody>
            ${reportData.map(row => `
              <tr>
                <td>${row.partyName}</td>
                <td>${row.totalQty}</td>
             <td>${row.totalKg} ${row.unitType}</td>
                <td>${row.totalAmount.toFixed(2)}</td>
              </tr>
            `).join("")}
          </tbody>

          <tfoot>
            <tr>
              <td>Total</td>
              <td>${totalQty}</td>
              <td>${totalKg}</td>
              <td>${totalAmount.toFixed(2)}</td>
            </tr>
          </tfoot>

        </table>

      </div>

    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.onload = function () {
    printWindow.print();
    printWindow.close();
  };
};
  return (
    <div className="billwise-container">

      
      <div className="billwise-table-section">

        <div className="billwise-table-wrapper">
          <table className="billwise-table">

            <thead>
              <tr>
                <th>Supplier</th>
                <th>Tot Qty</th>
                <th>U/A</th>
                <th>Tot Amt</th>
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.partyName}</td>
                    <td>{row.totalQty}</td>
                   <td>{row.totalKg} {row.unitType}</td>
                    <td>{row.totalAmount.toFixed(2)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="no-data">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

        <div className="del-summary">

  <div className="del-summary-row">

    <div className="summary-field ">
      <label>Total Qty</label>
      <input value={Number(totalQty).toFixed(2)} readOnly />
    </div>

    <div className="summary-field ">
      <label>Total U/A</label>
      <input value={Number(totalKg).toFixed(2)} readOnly />
    </div>

     <div className="summary-field total">
      <label>Total Amount</label>
      <input value={Number(totalAmount).toFixed(2)} readOnly />
    </div>


  </div>

</div>

       

        <div className="billwise-buttons">
          <button onClick={handlePrint}>Print</button>
        </div>

      </div>
    </div>
  );
}